import { SelectBox } from 'devextreme-react'
import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import { toast } from 'react-toastify'
import { FormGroup, Label } from 'reactstrap'
import Swal from 'sweetalert2'
import { getAllWarehouses } from '../../../services/apis'
import useFormatMessage from '../../../utils/useFormatMessage'

const DepoSecimi = () => {
    const [depoList, setDepoList] = useState([])
    const { t } = useFormatMessage()
    const [depo, setDepo] = useState(null)
    const [isLoading, setIsLoading] = useState(true)

    const showDepoSelectionSwal = (warehouses = [], hasError = false) => {
        let selectedValue = null;
        let selectedName = '';

        const SwalContent = () => {
            // Her render'da güncel warehouses listesini kullan
            return (
                <div>
                    <div style={{ fontSize: '18px', marginBottom: '20px' }}>
                        {(hasError || warehouses.length === 0) ? (
                            <div className="text-danger">
                                {t('Depo listesi yüklenirken hata oluştu. Lütfen internet bağlantınızı kontrol edip tekrar deneyin.')}
                            </div>
                        ) : (
                            selectedName ? `${selectedName} seçtiniz` : 'Lütfen bir depo seçiniz'
                        )}
                    </div>
                    <SelectBox
                        items={warehouses}
                        displayExpr="warehouse_name"
                        valueExpr="warehouse_code"
                        disabled={hasError || warehouses.length === 0}
                        onValueChanged={(e) => {
                            selectedValue = e.value;
                            const selectedWarehouse = warehouses.find(x => x.warehouse_code === e.value);
                            selectedName = selectedWarehouse ? selectedWarehouse.warehouse_name : '';

                            const textElement = document.querySelector('#selected-warehouse-text');
                            if (textElement) {
                                textElement.textContent = selectedName ? `${selectedName} seçtiniz` : 'Lütfen bir depo seçiniz';
                            }

                            const confirmButton = Swal.getConfirmButton();
                            if (confirmButton) {
                                confirmButton.disabled = !selectedValue;
                            }

                            if (selectedValue && selectedWarehouse) {
                                localStorage.setItem("warehouse", Buffer.from(
                                    selectedWarehouse.id.toString()).toString('base64')
                                );
                                localStorage.setItem("warehouseName", selectedWarehouse.warehouse_name);
                                setDepo(selectedValue);
                            }
                        }}
                        width="100%"
                        searchEnabled={true}
                        showClearButton={!hasError && warehouses.length > 0}
                    />
                    {(hasError || warehouses.length === 0) && (
                        <button
                            className="btn btn-primary mt-3 w-100"
                            onClick={fetchDepoList}
                        >
                            {t('Tekrar Dene')}
                        </button>
                    )}
                </div>
            );
        };

        const swalInstance = Swal.fire({
            title: t('Depo Seçimi'),
            html: '<div id="swal-depo-container"></div>',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showCancelButton: false,
            confirmButtonText: t('Seç'),
            confirmButtonColor: '#3085d6',
            width: '500px',
            customClass: {
                container: 'my-swal',
                popup: 'my-swal-popup',
                header: 'my-swal-header',
                title: 'my-swal-title',
                closeButton: 'my-swal-close-button',
                content: 'my-swal-content',
                input: 'my-swal-input',
                actions: 'my-swal-actions',
                confirmButton: 'my-swal-confirm-button'
            },
            didOpen: () => {
                const container = document.getElementById('swal-depo-container');
                ReactDOM.render(<SwalContent />, container);

                const confirmButton = Swal.getConfirmButton();
                if (confirmButton) {
                    confirmButton.disabled = !selectedValue;
                }

                const style = document.createElement('style');
                style.innerHTML = `
                    .my-swal-popup {
                        font-size: 1.2em !important;
                        border-radius: 15px;
                    }
                    .my-swal-title {
                        font-size: 1.5em !important;
                        padding: 1em;
                        color: #333;
                    }
                    .my-swal-content {
                        padding: 0 2em 2em;
                    }
                    .my-swal-confirm-button {
                        padding: 12px 30px !important;
                        font-size: 1.1em !important;
                        border-radius: 8px !important;
                    }
                    .dx-selectbox {
                        margin-top: 15px;
                    }
                    .dx-texteditor-input {
                        padding: 8px 12px !important;
                        font-size: 1.1em !important;
                    }
                `;
                document.head.appendChild(style);
            },
            preConfirm: () => {
                if (!selectedValue) {
                    Swal.showValidationMessage(t('Lütfen bir depo seçiniz'));
                    return false;
                }
                return selectedValue;
            },
            willClose: () => {
                if ((hasError || warehouses.length === 0) || !selectedValue) {
                    return false;
                }
                const container = document.getElementById('swal-depo-container');
                if (container) {
                    ReactDOM.unmountComponentAtNode(container);
                }
            }
        }).then((result) => {
            if (result.isConfirmed && result.value) {
                handleWarehouseChange(result.value);
            }
        });

        return swalInstance;
    };

    const fetchDepoList = async () => {
        let swalInstance = null;
        setIsLoading(true);
        try {
            const res = await getAllWarehouses();
            if (!res) {
                throw new Error('Veri alınamadı');
            }

            let all_Data = res;

            if (res.length === 0) {
                throw new Error('Aktif depo bulunamadı');
            }
            setDepoList(res);

            const storedWarehouseId = localStorage.getItem("warehouse")
                ? parseInt(Buffer.from(localStorage.getItem("warehouse"), 'base64').toString('ascii'))
                : null;

            if (storedWarehouseId) {
                const foundWarehouse = all_Data.find(x => x.id === storedWarehouseId);
                if (foundWarehouse) {
                    setDepo(foundWarehouse.warehouse_code);
                } else {
                    swalInstance = await showDepoSelectionSwal(all_Data, false);
                }
            } else {
                swalInstance = await showDepoSelectionSwal(all_Data, false);
            }

            setIsLoading(false);
        } catch (err) {
            console.error(err);
            setIsLoading(false);
            toast.error(t('Depo listesi getirilirken hata oluştu'));
            swalInstance = await showDepoSelectionSwal([], true);
        }
    };

    useEffect(() => {
        fetchDepoList();
        // eslint-disable-next-line
    }, []);

    const handleWarehouseChange = (selectedWarehouse) => {
        setDepo(selectedWarehouse);
        if (selectedWarehouse) {
            let data = depoList.find(x => x.warehouse_code === selectedWarehouse);
            if (data) {

                localStorage.setItem("warehouse", Buffer.from(
                    data.id.toString()).toString('base64'));
                console.log("TESSSTT", data.warehouse_name);
                localStorage.setItem("warehouseName", data.warehouse_name);
            }
        }
    };

    return (
        <FormGroup className='d-flex align-items-center w-100 m-0 justify-content-end'>
            <Label for="depo" className='m-0' style={{
                whiteSpace: "nowrap",
            }}><b>{t('DEPO')} &emsp;</b></Label>
            <SelectBox
                id='depo-select-box'
                value={depo}
                onValueChange={handleWarehouseChange}
                items={depoList}
                displayExpr="warehouse_name"
                valueExpr="warehouse_code"
                disabled={isLoading || depoList.length === 0}
            />
        </FormGroup>
    );
};

export default DepoSecimi;